let { infoConfig, loginUserModel } = window.platformData() || {};
let globalData = window.globalData() || {};

const isEmptyObj = (obj) => {
  return !obj || (obj && !Object.keys(obj).length);
};

let globalMixin = {
  data() {
    return {
      infoConfig,
      loginUserModel: isEmptyObj(loginUserModel)
        ? JSON.parse(localStorage.getItem("loginUserModel"))
        : loginUserModel,
      globalData,
    };
  },
  computed: {
    isShowPrice() {
      if (this.globalData) {
        return this.globalData.isShowPrice;
      }
    },
    isShowCart() {
      if (this.globalData) {
        return this.globalData.isShowCart;
      }
    },
    isLogged() {
      // // return !!this.loginUserModel;
      return localStorage.getItem("loginToken") || false;
      return localStorage.getItem("loginToken") || false;
    },
    isStudent() {
      return (
        !!this.loginUserModel &&
        this.loginUserModel.userType &&
        "STUDENT" === this.loginUserModel.userType.code
      );
    },

    isManager() {
      return (
        !!this.loginUserModel &&
        this.loginUserModel.userType &&
        "MANAGER" === this.loginUserModel.userType.code
      );
    },
    pageUri() {
      return window.location.pathname;
    },
    pageQuery() {
      let search = window.location.search;
      let query = {};
      if (search) {
        if (search.startsWith("?")) {
          search = search.substring(1);
        }
        let params = search.split("&");
        params.forEach((param) => {
          let split = param.indexOf("=");
          if (split > 0) {
            let key = param.substring(0, split);
            let val = decodeURIComponent(param.substring(split + 1));
            let value;
            if (query.hasOwnProperty(key)) {
              value = query[key];
              if (!Array.isArray(value)) {
                value = [value];
              }
              value.push(val);
            } else {
              value = val;
            }
            query[key] = value;
          }
        });
      }
      return query;
    },
    pageHash() {
      let hash = window.location.hash;
      if (hash) {
        if (hash.startsWith("#")) {
          hash = hash.substring(1);
        }
        return hash;
      }
    },
  },
  methods: {
    toUrl(location) {
      window.location.href = location;
    },
    reloadUrl() {
      window.location.reload();
    },
    loginResolve() {
      return new Promise((resolve, reject) => {
        if (this.isLogged) {
          if (this.isStudent) {
            resolve();
          } else {
            this.$message.closeAll();
            this.$message.warning("您没有访问该功能的权限");
          }
        } else {
          let headVm = window.HeadVm;
          if (headVm) {
            headVm.onUserLogin((isOk) => {
              if (isOk) {
                // 登录成功后会刷新页面
              } else {
                reject(new Error("用户取消登录"));
              }
            });
          } else {
            reject(new Error("头部组件未完成初始化"));
          }
        }
      });
    },
    openUrl(location) {
      window.open(location);
    },

    /**元素进入可视区
     * 有无浏览器兼容性问题，未测试
     * @param {回调：值为true进入可视区，false离开可视区} callback
     * @param {标签元素} el
     */
    elEntryClient(callback, el) {
      var observer = new IntersectionObserver((entries) => {
        const curEntry = entries && entries.length > 0 && entries[0];
        callback(curEntry.isIntersecting);
      });
      observer.observe(el);
    },
  },
};
